import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router';
import { createBrowserHistory } from "history";

import App from './App';

import 'react-toastify/dist/ReactToastify.css';
import Toast from "./components/toast";
const history = createBrowserHistory({ forceRefresh: true });

ReactDOM.render(
  <React.StrictMode>
    <Router history={history}>
        <Toast />
         <App />
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
